import React, { useEffect, useState } from 'react';
import {Button, Box, Grid, Typography } from '@mui/material';
import tableHeadersMapping from '../components/reports/tableHeader';
import contentMapping from '../components/reports/contentMapping';
import AuthenticationPerformanceFilterComponent from '../components/reports/reports-filter/authentication-performance-filter.component';
import AnomalyDetectionFilterComponent from '../components/reports/reports-filter/anomaly-detection-filter.component';
import GeolocationVerificationFilterComponent from '../components/reports/reports-filter/geolocation-verification-filter.component';
import ProductSpecifiVerificationFilterComponent from '../components/reports/reports-filter/product-specific-verification-filter.component';
import UserActivityFilterComponent from '../components/reports/reports-filter/user-activity-filter.component';
import VerificationFrequencyFilterComponent from '../components/reports/reports-filter/verification-frequency-filter.component';
import AlertsAndNotificationsFilterComponent from '../components/reports/reports-filter/alerts-and-notifications-filter.component';
import ReportLogsListComponent from "../components/reports/report-logs/report-logs-list.component";
import useReport from '../hooks/useReport';
import useFilters from '../hooks/useFilters';
import OfflineIcon from "../assets/images/offline.png";

const ReportsScreen = () => {
    const url = window.location.pathname;
    const headers = tableHeadersMapping[url] || [];
    const content = contentMapping[url] || { title: 'Report', description: 'Report summary' };

    const [page, setPage] = useState(1)

    const {getAuthenticationPerformance, reportPerformance, isLoading, pagination, loadingVerification, getGeolocationVerification, 
        geolocationVerification, getAnomalyDetection, isLoadingAnomaly, anomalyList, getAlertList, alertList, isLoadingAlertList,
        getVerificationFrequency,loadingVerificationFrequency, listVerificationFrequency, getProductVerification, isLoadingProductVerification, listProductVerification,
        userActivityList, isLoadingUserActivity, getUserActivity,} = useReport()
        
    const {getListFilterProduct, listProducts, getUserTypes, listUserTypes, getCountry, listOfCountry, getRegion, regionList, getProvince, listOfProvince, getCityMunicipality, listOfCityMuni,
         getUserEmail, emailList, getModule, moduleList} = useFilters()

    const [isOnline, setOnline] = useState(navigator.onLine);


    useEffect(() => {
        const handleOnline = () => setOnline(true);
        const handleOffline = () => setOnline(false);
    
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        }
    },  []);

    useEffect(()=>{
        getListFilterProduct()
    },[])

    useEffect(()=>{
        getCountry()
    },[])


    // Example data here
    const data = [
        {
            'Authentication ID': '12345',
            'Authentication Time': 'May 29, 2024 8:40:02 PM',
            'Authentication Status': 'Success',
            'Failure Reason': 'N/A',
            'Product Ref': 'Product001',
            'Timestamp': 'May 29, 2024 8:40:02 PM',
            'User ID': 'User001',
            'Alert ID' : '1',
            'Verification ID' : '0012'
        },
    ];

    const renderFilter = (headers, getAuthenticationPerformance, isLoading, listProducts, 
        loadingVerification, getGeolocationVerification, geolocationVerification, setPage, page, pagination, getAnomalyDetection, isLoadingAnomaly, anomalyList, getAlertList, alertList, isLoadingAlertList, 
        getUserTypes, listUserTypes, listOfCountry, getRegion, regionList, getProvince, listOfProvince, getCityMunicipality, listOfCityMuni, getVerificationFrequency,loadingVerificationFrequency, listVerificationFrequency,
        getProductVerification, isLoadingProductVerification, listProductVerification, userActivityList, isLoadingUserActivity, getUserActivity, getUserEmail, emailList, getModule, moduleList) => {
        switch (url) {
            case '/reports/authentication-performance':
                return <AuthenticationPerformanceFilterComponent getAuthenticationPerformance={getAuthenticationPerformance} headers={headers} reportPerformance={reportPerformance} 
               isLoading={isLoading} setPage={setPage} paginaton={pagination} listProducts={listProducts} page={page}/>;
            case '/reports/anomaly-detection':
                return <AnomalyDetectionFilterComponent getAnomalyDetection={getAnomalyDetection} headers={headers} anomalyList={anomalyList} isLoadingAnomaly={isLoadingAnomaly} 
                listProducts={listProducts} page={page} setPage={setPage} listOfCountry={listOfCountry} 
                getRegion={getRegion} regionList={regionList} getProvince={getProvince} listOfProvince={listOfProvince} getCityMunicipality={getCityMunicipality} listOfCityMuni={listOfCityMuni} />;
            case '/reports/geolocation-verification':
                return <GeolocationVerificationFilterComponent headers={headers} listProducts={listProducts} isLoadingVerification={loadingVerification} getGeolocationVerification={getGeolocationVerification}
                page={page} setPage={setPage} geolocationVerification={geolocationVerification} listOfCountry={listOfCountry} 
                getRegion={getRegion} regionList={regionList} getProvince={getProvince} listOfProvince={listOfProvince} getCityMunicipality={getCityMunicipality} listOfCityMuni={listOfCityMuni} />;
            case '/reports/product-specific-verification':
                return <ProductSpecifiVerificationFilterComponent  headers={headers} listProducts={listProducts} getProductVerification={getProductVerification} isLoadingProductVerification={isLoadingProductVerification} listProductVerification={listProductVerification} listOfCountry={listOfCountry} 
                getRegion={getRegion} regionList={regionList} getProvince={getProvince} listOfProvince={listOfProvince} getCityMunicipality={getCityMunicipality} listOfCityMuni={listOfCityMuni} page={page} setPage={setPage}/>;
            case '/reports/user-activity':
                return <UserActivityFilterComponent headers={headers} userActivityList={userActivityList} isLoadingUserActivity={isLoadingUserActivity} getUserActivity={getUserActivity} page={page} setPage={setPage} getUserEmail={getUserEmail} emailList={emailList}
                getModule={getModule} moduleList={moduleList} />;
            case '/reports/verification-frequency':
                return <VerificationFrequencyFilterComponent 
                    headers={headers} 
                    getVerificationFrequency={getVerificationFrequency} 
                    loadingVerificationFrequency={loadingVerificationFrequency} 
                    listVerificationFrequency={listVerificationFrequency} 
                    page={page} 
                    setPage={setPage} 
                    getUserTypes={getUserTypes} 
                    listUserTypes={listUserTypes} 
                    listProducts={listProducts}
                />;
            // case '/reports/audit-trail':
            //     return <AuditTrailFilterComponent />;
            case '/reports/alerts-notifications':
                return <AlertsAndNotificationsFilterComponent  
                    headers={headers} 
                    getAlertList={getAlertList} 
                    isLoadingAlertList={isLoadingAlertList} 
                    alertList={alertList} 
                    getUserTypes={getUserTypes} 
                    listUserTypes={listUserTypes} 
                    page={page} 
                    setPage={setPage} 
                    getUserEmail={getUserEmail} 
                    emailList={emailList} 
                />;
            
            case "/reports/report-logs-list":
                return <ReportLogsListComponent getUserEmail={getUserEmail} emailList={emailList} />;

            default:
                return null;
        }
    };

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ color: "#58565f", fontWeight: 600, fontSize: 20 }}>
                        {content.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#58565fd4", fontSize: 14 }}>
                        {content.description}
                    </Typography>
                </Grid>
            </Grid>

            {(isOnline) ?  
                <Box sx={{ mt: 1 }}>{renderFilter(headers, getAuthenticationPerformance, isLoading, listProducts, loadingVerification, 
                    getGeolocationVerification, geolocationVerification, setPage, page, pagination, getAnomalyDetection, isLoadingAnomaly, 
                    anomalyList, getAlertList, alertList, isLoadingAlertList, getUserTypes, listUserTypes, listOfCountry, getRegion, regionList, 
                    getProvince, listOfProvince, getCityMunicipality, listOfCityMuni, getVerificationFrequency,loadingVerificationFrequency, 
                    listVerificationFrequency, getProductVerification, isLoadingProductVerification, listProductVerification,
                    userActivityList, isLoadingUserActivity, getUserActivity, getUserEmail, emailList, getModule, moduleList)}
                </Box>
            :
                <Box sx={{textAlign: "center", mt: 20}}>  
                    <img alt="" src={OfflineIcon} style={{height: 80, marginBottom: "16px"}} />

                    <Typography sx={{fontSize: 20, fontWeight: "bold", mb: 0.5, color: "#58565f"}}>
                        Ooops!
                    </Typography>

                    <Typography sx={{color: "#58565fd4"}}>
                        Failed to load data.
                    </Typography>

                    <Typography sx={{color: "#58565fd4"}}>
                        Please check your internet connection or try again.
                    </Typography>

                    <Button variant="contained" sx={{mt: 2.5, bgcolor: '#3333cf', textTransform:'none'}} onClick={() => window.location.reload()}>
                        Try again
                    </Button>
                </Box>
            }
        </Box>
    )
}

export default ReportsScreen
